import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import { flattenData } from "../../../../Utilitie";
import * as echarts from "echarts";

const MonthWisePWIHOLoadedEmptyGraphHO = ({
  selectedMonths,
  selectedSections,
  sortedPrev,
  sortedCurr,
  selectedRT,
  selectedFy,
}) => {
  const getSectionData = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};
  useEffect(() => {
    if (selectedMonths.length === 0 || selectedSections.length === 0) return;

    const chartDom = document.getElementById("HOpwiChart4");
    let myChart = echarts.init(chartDom);

    ////////////////////////////////////////

    //////////////////////////////////////////////  ////////////////////////////////////////

    const prevLTotalHO = selectedMonths.map((month) => {
      const m = sortedPrev.find((o) => o.month.slice(0, 3) === month);
      return selectedSections.reduce((acc, s) => {
        const d = getSectionData(m, s);
        return acc + Number(d[`${selectedRT.toLowerCase()}_ho_loaded`] || 0);
      }, 0);
    });

    const currLTotalHO = selectedMonths.map((month) => {
      const m = sortedCurr.find((o) => o.month.slice(0, 3) === month);
      return selectedSections.reduce((acc, s) => {
        const d = getSectionData(m, s);
        return acc + Number(d[`${selectedRT.toLowerCase()}_ho_loaded`] || 0);
      }, 0);
    });

    /////////////////////////////////////////////
    const prevETotalHO = selectedMonths.map((month) => {
      const m = sortedPrev.find((o) => o.month.slice(0, 3) === month);
      return selectedSections.reduce((acc, s) => {
        const d = getSectionData(m, s);
        return acc + Number(d[`${selectedRT.toLowerCase()}_ho_empty`] || 0);
      }, 0);
    });

    const currETotalHO = selectedMonths.map((month) => {
      const m = sortedCurr.find((o) => o.month.slice(0, 3) === month);
      return selectedSections.reduce((acc, s) => {
        const d = getSectionData(m, s);
        return acc + Number(d[`${selectedRT.toLowerCase()}_ho_empty`] || 0);
      }, 0);
    });

    //////////////////////////////////////////////

    ////////////////////////////////

    const option = {
      title: {
        text: `HO L & E – Prev (${selectedFy.replace(
          /\d+/g,
          (y) => +y - 1
        )}) vs Curr Year (${selectedFy})`,
        left: "center",
      },
      tooltip: {
        trigger: "axis",
      },
      legend: {
        top: 30,
        data: [
          `H/O L (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          `H/O L (${selectedFy})`,
          `H/O E (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          `H/O E (${selectedFy})`,
        ],
      },
      xAxis: {
        type: "category",
        data: selectedMonths,
      },
      yAxis: {
        type: "value",
      },
      series: [
        {
          name: `H/O L (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          type: "bar",
          data: prevLTotalHO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
        {
          name: `H/O L (${selectedFy})`,
          type: "bar",
          smooth: true,
          data: currLTotalHO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
        {
          name: `H/O E (${selectedFy.replace(/\d+/g, (y) => +y - 1)})`,
          type: "bar",
          data: prevETotalHO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
        {
          name: `H/O E (${selectedFy})`,
          type: "bar",
          smooth: true,
          data: currETotalHO,
          label: {
            show: true,
            position: "top",
            rotate: 55,
            fontSize: 12,
            verticalAlign: "middle",
          },
        },
      ],
    };
    myChart.setOption(option);

    const handleResize = () => {
      myChart.resize();
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      myChart.dispose();
    };
  }, [selectedMonths, selectedSections, sortedPrev, sortedCurr, selectedRT]);

  return (
    <div>
      <div className="papaDiv">
        <div
          id="HOpwiChart4"
          style={{ width: "100%", height: "50vh", marginTop: "30px" }}
        ></div>
      </div>
    </div>
  );
};

export default MonthWisePWIHOLoadedEmptyGraphHO;
